import {
  type EndpointResponse,
  type PredicateType,
  type ResponseBodyEvaluation,
  type TeamExternalIntegration
} from 'types/api/status-checks/status-check'
import { getDatadogEUMonitorIdFromUrl } from 'utils/status-checks/status-check-integrations-util-datadog-eu'
import { getDatadogUS1FEDMonitorIdFromUrl } from 'utils/status-checks/status-check-integrations-util-datadog-us1-fed'
import { getDatadogUS3MonitorIdFromUrl } from 'utils/status-checks/status-check-integrations-util-datadog-us3'
import { getDatadogUS5MonitorIdFromUrl } from 'utils/status-checks/status-check-integrations-util-datadog-us5'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'
import { ENDPOINT_URLS } from 'utils/third-party'

export const dataDogStatusCheckIntegration: TeamExternalIntegration = {
  name: 'Datadog',
  type: IntegrationType.Datadog,
  authUrl: `${ENDPOINT_URLS.datadog}v2/current_user/application_keys`,
  isPrivateNetworkIntegration: false,
  headers: [
    { key: 'DD-API-KEY', value: '', label: 'API Key' },
    {
      key: 'DD-APPLICATION-KEY',
      value: '',
      label: 'Application Key'
    }
  ],
  url: ENDPOINT_URLS.datadog,
  sortIndex: 0
}

export const datadogMonitorRegex = new RegExp(
  '^https:\\/\\/(app|api).datadoghq.com\\/(monitors|api/v1/monitor)\\/(.+\\d)'
)

export const datadogResponseBodyEvaluationConfiguration: ResponseBodyEvaluation =
  {
    op: 'AND',
    predicates: [
      {
        jpQuery: '.overall_state',
        type: 'String' as PredicateType,
        comparator: 'EQU',
        rValue: 'OK'
      }
    ]
  }

export function getDatadogMonitorIdFromUrl(url: string): string {
  return datadogMonitorRegex.exec(url)?.[3]
}

export function convertToDatadogApiUrl(url: string): string {
  if (datadogMonitorRegex.test(url)) {
    const isAPIUrl = datadogMonitorRegex.exec(url)?.[2] === 'api/v1/monitor'
    const monitorId = getDatadogMonitorIdFromUrl(url)

    if (isAPIUrl) {
      return url
    }

    if (monitorId) {
      return `https://api.datadoghq.com/api/v1/monitor/${monitorId}`
    }
  }

  return null
}

export function getDatadogMonitorName(
  testEndpointResponse: EndpointResponse
): string {
  return JSON.parse(testEndpointResponse?.responseBody)?.name
}

export const DATADOG_MONITOR_URL_PREFIX = 'v1/monitor/'

export function getDatadogMonitorIdFromIntegration(
  integration: TeamExternalIntegration
) {
  if (integration.observabilityToolType !== 'DATADOG') {
    return null
  }

  switch (integration.domain) {
    case 'US1FED':
      return getDatadogUS1FEDMonitorIdFromUrl(integration.url)

    case 'US3':
      return getDatadogUS3MonitorIdFromUrl(integration.url)

    case 'US5':
      return getDatadogUS5MonitorIdFromUrl(integration.url)

    case 'EU':
      return getDatadogEUMonitorIdFromUrl(integration.url)

    default:
    case 'US1':
      return getDatadogMonitorIdFromUrl(integration.url)
  }
}
